Controller.$inject = ['$element', '$scope'];

function Controller($element, $scope) {
    const self = this;

    self.$onInit = function() {
        $scope.$watchGroup(['$huiCtrl.level', '$huiCtrl.hasExpanded', '$huiCtrl.parentLevel'], function() {
            self.updateStyles();
        });

        // Listen for custom cellExpandClick event from child cells
        const trElement = $element[0];
        trElement.addEventListener('cellExpandClick', function() {
            if (self.onRowExpand) {
                self.onRowExpand();
            }
        });
    };

    self.updateStyles = function() {
        const styles = {};
        
        if (self.hasExpanded && self.level !== undefined) {
            styles['--level'] = self.level;
        }
        
        if (self.parentLevel !== undefined) {
            styles['--parent-level'] = self.parentLevel;
        }
        
        self.computedStyles = styles;
    };
}

export function HuiTr() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            deleted: '<',
            highlighted: '<',
            isFooter: '<',
            expanded: '<',
            level: '<',
            loading: '<',
            parentLevel: '<',
            hasExpanded: '<',
            isHeader: '<',
            bgColor: '@',
            onRowExpand: '&'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <tr ng-class="[
                        !!$huiCtrl.deleted ? 'deleted' : '',
                        !!$huiCtrl.highlighted ? 'highlighted' : '',
                        !!$huiCtrl.isFooter ? 'footer' : '',
                        !!$huiCtrl.isHeader ? 'is-header' : '',
                        !!$huiCtrl.hasExpanded ? 'has-expanded' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === false ? 'row-closed' : '',
                        !!$huiCtrl.hasExpanded && $huiCtrl.expanded === true ? 'row-expanded' : '',
                        !!$huiCtrl.hasExpanded && !!$huiCtrl.loading ? 'loading' : '',
                        $huiCtrl.bgColor ? 'hui-bg-' + $huiCtrl.bgColor : ''
                   ]"
                   ng-style="$huiCtrl.computedStyles"
                   ng-transclude>
            </tr>
            `;
        }
    };
}



